type ClassValues = string | number | bigint | null | boolean | undefined;
type ClassValue = ClassValue[] | Record<string, ClassValues> | ClassValues;

/**
 * Combines multiple class names into a single string.
 *
 * @param inputs ClassValue[]
 */
export default function cn(...inputs: ClassValue[]): string {
    return inputs.map(toVal).filter(Boolean).join(" ");
}

const toVal = (value: ClassValue): string => {
    if (typeof value === "string") {
        return value;
    }

    if (typeof value === "number" && value > 0) {
        return value.toString();
    }

    if (Array.isArray(value)) {
        return value.filter(Boolean).map(toVal).join(" ");
    }

    if (typeof value === "object" && value !== null) {
        return Object.keys(value)
            .filter((key): ClassValues => value[key])
            .join(" ");
    }

    return "";
};
